import ouiStyle from '@goldwasserexchange/oui-style';
import { inputIconContainerStyle } from '../../../../../shared';

export const textInputIconContainerStyle: ouiStyle.InStyle = {
  ...inputIconContainerStyle,
  parentBorderBottomWidth: 'simple',
};
